import React from "react";
import styled from "styled-components";
//

export default ({ link, link_title, ...rest }) => (
  <Wrap>
    <a target="_blank" href={link.url} title={link.name}>
      {link_title}
    </a>
  </Wrap>
);
//
const Wrap = styled.li`
  margin: 0.25rem;

  :last-child {
    border: none;
  }

  @media (min-width: 769px) {
    border: none;
    display: initial;
    padding: 0 1rem;
    :first-child {
      padding-top: 0.5rem;
    }
    :last-child {
      height: 100vh;
    }
    &:not(:last-child):after {
      background-color: currentColor;
      content: "";
      display: block;
      height: 2px;
      margin: 0.5rem 0;
      width: 1rem;
    }
  }
`;
